import { KeyedObject } from 'bernie-core/dist/source';
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';

export class AdvertisingStore extends Store {
  public adsloader?: string;
  public adsloaderes5?: string;

  public constructor(state: SerializedData = {}, logger: Logger | ClientLogger = NOOP_LOGGER, appConfig?: KeyedObject) {
    super(state, logger);
    if (appConfig) {
      this.adsloader = appConfig.advertising.loaders.ads;
      this.adsloaderes5 = appConfig.advertising.loaders.adsES5;
    }
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
